import { useEffect, useRef, useState } from 'react'
import { Link } from 'react-router'
import { formatCouponExpiration, type Coupon } from '../../data/coupons'

export function CouponCard({ coupon }: { coupon: Coupon }) {
  const [copyStatus, setCopyStatus] = useState<'idle' | 'copied' | 'error'>('idle')
  const resetTimer = useRef<ReturnType<typeof setTimeout> | undefined>(undefined)
  useEffect(() => () => clearTimeout(resetTimer.current), [])

  const copyCode = async () => {
    clearTimeout(resetTimer.current)
    try {
      await navigator.clipboard.writeText(coupon.code)
      setCopyStatus('copied')
      resetTimer.current = setTimeout(() => setCopyStatus('idle'), 2500)
    } catch {
      setCopyStatus('error')
    }
  }

  return <section className="coupon-card" aria-labelledby={`coupon-${coupon.id}`}>
    <p className="coupon-category">{coupon.category}</p>
    <h2 id={`coupon-${coupon.id}`}>{coupon.title}</h2>
    <p className="coupon-description">{coupon.description}</p>
    <div className="coupon-code-row">
      <div><span className="coupon-code-label">Offer code</span><code>{coupon.code}</code></div>
      <button type="button" onClick={copyCode} aria-label={`${copyStatus === 'copied' ? 'Copied!' : 'Copy Code'} ${coupon.code}`}>{copyStatus === 'copied' ? 'Copied!' : 'Copy Code'}</button>
    </div>
    <p className="coupon-copy-status" role="status" aria-live="polite">{copyStatus === 'copied' ? `${coupon.code} copied to clipboard.` : copyStatus === 'error' ? `Could not copy automatically. Select and copy ${coupon.code} above.` : ''}</p>
    <div className="coupon-terms"><h3>Offer details</h3><p>{coupon.terms}</p>
      {coupon.expiresAt && <p className="coupon-expiry">Valid through <time dateTime={coupon.expiresAt}>{formatCouponExpiration(coupon.expiresAt)}</time></p>}
    </div>
    <div className="coupon-actions">
      <p>{coupon.inStore ? 'Show this coupon at checkout.' : 'Mention this code when you send your inquiry.'}</p>
      <Link className="service-button service-button--primary" to={coupon.ctaHref}>{coupon.ctaLabel}<span className="sr-only">: {coupon.title}</span></Link>
    </div>
  </section>
}
